import script from "./common-content.vue?vue&type=script&lang=ts&setup=true"
export * from "./common-content.vue?vue&type=script&lang=ts&setup=true"

import "./common-content.vue?vue&type=style&index=0&id=0333d49d&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0333d49d"]])

export default __exports__